import React, { useState } from 'react';
import { Toolbar, AppBar, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { BASE_URL, IMAGE_PATHS } from '../../../constants/paths.constants';
import { darkGrey } from '../../../app/theme';
import history from '../../../services/browserHistory';
import { BASE_ROUTE } from '../../../constants/trainingNav.constants';
import ContactSpecialistModal from '../ContactSpecialistModal/ContactSpecialistModal';

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    height: 85,
  },
  topToolbar: {
    display: 'flex',
    width: '100%',
    height: 85,
    backgroundColor: '#fff',
  },
  logo: {
    paddingLeft: 41,
    height: 66,
    paddingRight: 64,
    paddingTop: 16,
    paddingBottom: 6,
    zIndex: 10,
  },
  nav: {
    width: 'calc(100% - 310px)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  hidden: {
    visibility: 'hidden',
  },
  arrow: {
    width: 9,
  },
  button: {
    textTransform: 'none',
    color: darkGrey,
    fontSize: 16,
    fontWeight: 600,
  },
}));

interface Props {
  section: string;
}

interface NavBarItem {
  title: string;
  action: () => void;
}

const AxuminNavBar = ({ section }: Props): JSX.Element => {
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleAccessModalOpen = (isOpen: boolean) => {
    setIsModalOpen(isOpen);
  };

  const handleClickHome = () => {
    history.push('/axumin');
  };
  const handleClickImageInterpretation = () => {
    history.push(BASE_ROUTE.axuminInterpretation);
  };
  const handleClickImageAcquisition = () => {
    history.push(BASE_ROUTE.axuminAcquisition);
  };
  const handleClickContactImagingSpecialist = () => {
    setIsModalOpen(true);
  };
  const handleClickDownloadableResources = () => {
    history.push('/axumin/downloadableresources');
  };

  const sections = [
    {
      title: 'Home',
      action: handleClickHome,
    },
    {
      title: 'Image Acquisition',
      action: handleClickImageAcquisition,
    },
    {
      title: 'Image Interpretation',
      action: handleClickImageInterpretation,
    },
    {
      title: 'Downloadable Resources',
      action: handleClickDownloadableResources,
    },
    {
      title: 'Contact Imaging Specialist',
      action: handleClickContactImagingSpecialist,
    },
  ];

  const renderNavBarItem = (item: NavBarItem) => {
    return (
      <div key={item.title}>
        <img
          className={classNames(classes.arrow, {
            [classes.hidden]:
              (section !== item.title || isModalOpen) && !(item.title === 'Contact Imaging Specialist' && isModalOpen),
          })}
          src={`${BASE_URL}${IMAGE_PATHS.TRAINING_PAGES[1].NAVIGATION_ARROW.path}`}
          alt={`${IMAGE_PATHS.TRAINING_PAGES[1].NAVIGATION_ARROW.alt}`}
        />
        <Button color="secondary" className={classes.button} onClick={item.action}>
          {item.title}
        </Button>
      </div>
    );
  };

  return (
    <AppBar className={classes.root} position="static">
      <Toolbar className={classes.topToolbar}>
        <img
          className={classes.logo}
          src={`${BASE_URL}${IMAGE_PATHS.TRAINING_PAGES[1].LOGO.path}`}
          alt={`${IMAGE_PATHS.TRAINING_PAGES[1].LOGO.alt}`}
        />
        <div className={classes.nav}>{sections.map((item) => renderNavBarItem(item))}</div>
      </Toolbar>
      <ContactSpecialistModal
        isOpen={isModalOpen}
        handleModalOpen={(isOpen: boolean) => handleAccessModalOpen(isOpen)}
      />
    </AppBar>
  );
};

export default AxuminNavBar;
